export function stickify() {
    const stickyParent = document.querySelector(".wrapper");

    function toggleSticky() {
        setTimeout(() => {
            if (window.innerWidth > 1023) {
                stickyParent.style.overflow = "visible";
            } else {
                stickyParent.style.overflow = "hidden";
            }
        }, 500);
    }

    if ($(".collection-detail-heading, .news-listing").length) {
        toggleSticky();
        window.addEventListener("orientationchange", toggleSticky);
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/stickify.js